<template>
    <v-container>
        <v-row>
            <v-col>
                <v-card>
                    <v-card-title>
                        Konfiguracja wysyłki SMS
                    </v-card-title>
                    <v-card-text>
                        <v-alert type="info">Użytkownik i hasło są używane do wysyłania SMS przez aplikację Android - SMS Gateway. Po uruchomieniu aplikacji należy wprowadzić adres URL: https://androidsms.poko.com.pl/api/mobile/v1 oraz token.</v-alert>
                        <v-form>
                            <v-text-field v-model="androidSMSUser" label="Użytkownik" />
                            <v-text-field v-model="androidSMSPassword" label="Hasło" />
                            <v-checkbox v-model="CleanEverything" label="Wyczyśc wszystko" />
                        </v-form>
                    </v-card-text>
                    <v-card-actions></v-card-actions>
                        <v-btn color="primary" @click="saveSettings">Zapisz</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { settingsService } from '@/services/companysettings.service'
import { mapActions } from 'vuex'

    export default {
    name: "AndroidSMSConfiguration",
    data() {
      return {
        androidSMSUser: null,
        androidSMSPassword: null,
        CleanEverything: false
      }
    },
    mounted() {
        this.getSettingsData()
    },
    methods: {
        ...mapActions("alert", ["error", "success"]),
        getSettingsData() {
            settingsService.GetCompanySettings().then(success=> {
                this.androidSMSUser = success.data.result.androidSmsUser
                this.androidSMSPassword = success.data.result.androidSmsPassword                
            })
        },
        saveSettings() {
            settingsService.registerAndroidSmsDevice({
                username: this.androidSMSUser,
                password: this.androidSMSPassword,
                cleanEverything: this.CleanEverything
            }).then(() => {
                this.success('Ustawienia zostały zapisane')
            })
        }
    }
}
</script>

<style scoped>

</style>